wbApp.factory('formResponseSvc', ['$resource', '$q','repositorySvc',
    function ($resource, $q, repositorySvc) {

        var FormResponse = $resource('/restapi/forms-responses/:id', {}, {
            'getById': { method: 'GET', url: '/restapi/forms-responses/:id' },
            'getAllByFormId': { method: 'GET', isArray: true, url: '/restapi/forms-responses/info/find-by-form-definition' },
            'insert': { method: 'POST', url: '/restapi/forms-responses' },
            'delete': { method: 'DELETE', url: '/restapi/forms-responses/:id' },
        });

        function getById(formResponseId) {
            return repositorySvc.customGet('getById', FormResponse, { id: formResponseId });
        }

        function getAllByFormId(formId) {
            return $q(function (resolve, reject) {
                var getResult = repositorySvc.customGet(
                    'getAllByFormId',
                    FormResponse,
                    {
                        formDefinitionId: formId,
                        expanded: 'PersonalInformation'
                    });

                getResult.$promise.then(
                    function (data) {
                        resolve(data);
                    },
                    function (error) {
                        reject(error);
                    });
            });
        }

        function insert(model) {
            return repositorySvc.customPost(
                'insert',
                FormResponse,
                model);
        }

        function remove(formResponseId) {
            return repositorySvc.customDelete(
                'delete',
                FormResponse,
                { id: formResponseId });
        }

        return {
            getById: getById,
            getAllByFormId: getAllByFormId,
            insert: insert,
            remove: remove,
        }
    }
]);